// extracted by mini-css-extract-plugin
export default {"picker":"Recipient_picker__KDJih"};